class FrappProductTabs {
  constructor(root) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
    });
  }

  activate(nextTab) {
    const panelId = nextTab.getAttribute('aria-controls');

    this.tabs.forEach((tab) => {
      const active = tab === nextTab;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      const active = panel.id === panelId;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  onKeydown(event, currentTab) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();
    const currentIndex = this.tabs.indexOf(currentTab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;

    this.activate(this.tabs[nextIndex]);
    this.tabs[nextIndex].focus();
  }
}

const initFrappProductTabs = (scope = document) => {
  scope.querySelectorAll('[data-frapp-product-tabs]').forEach((root) => {
    if (root.dataset.frappTabsReady === 'true') return;
    root.dataset.frappTabsReady = 'true';
    new FrappProductTabs(root);
  });
};

document.addEventListener('DOMContentLoaded', () => initFrappProductTabs());
document.addEventListener('shopify:section:load', (event) => initFrappProductTabs(event.target));
